import { combineReducers } from "@reduxjs/toolkit";

import EmbeddedVideoDetails from "./EmbeddedVideoDetailsSlice";
import EmbeddedVideosEntityState from "./EmbeddedVideosEntityStateSlice";
import EmbeddedVideosFilters from "./EmbeddedVideosFiltersSlice";
import EmbeddedVideosOverview from "./EmbeddedVideosOverviewSlice";
import EmbeddedVideosTags from "./EmbeddedVideosTagsSlice";

import EmbeddedVideoGroups from "./EmbeddedVideoGroupsSlice";
import EmbeddedVideoUsers from "./EmbeddedVideoUsersSlice";

const edit = combineReducers({
  users: EmbeddedVideoUsers,
  groups: EmbeddedVideoGroups,
});

export const EmbeddedVideosReducer = combineReducers({
  entitState: EmbeddedVideosEntityState,
  details: EmbeddedVideoDetails,
  overview: EmbeddedVideosOverview,
  tags: EmbeddedVideosTags,
  filters: EmbeddedVideosFilters,
  edit,
});

export type EmbeddedVideosState = ReturnType<typeof EmbeddedVideosReducer>;
